import { axiosInstance } from "./axiosInstanceFile";

export const postApi = async (endpoint, data, config = {}) => {
    try {
        const response = await axiosInstance.post(endpoint, data, config);
        return response.data;
    } catch (error) {
        throw error.response?.data || "An error occurred";
    }
};

export const putApi = async (endpoint, data, config = {}) => {
    try {
        const response = await axiosInstance.put(endpoint, data, config);
        return response.data;
    } catch (error) {
        throw error.response?.data || "An error occurred";
    }
};

export const patchApi = async (endpoint, data, config = {}) => {
    try {
        const response = await axiosInstance.patch(endpoint, data, config);
        return response.data;
    } catch (error) {
        throw error.response?.data || "An error occurred";
    }
};

export const getApi = async (endpoint, config = {}) => {
    try {
        const response = await axiosInstance.get(endpoint, config);
        return response.data;
    } catch (error) {
        throw error.response?.data || "An error occurred";
    }
};

export const deleteApi = async (endpoint, config = {}) => {
    try {
        const response = await axiosInstance.delete(endpoint, config);
        return response.data;
    } catch (error) {
        throw error.response?.data || "An error occurred";
    }
};

export const getApiquery = async (url, queryParams = {}) => {
    const query = new URLSearchParams(queryParams).toString();
    const fullUrl = query ? `${url}?${query}` : url;

    try {
        const response = await axiosInstance.get(fullUrl);
        return response.data;
    } catch (error) {
        throw error.response?.data || "An error occurred";
    }
};

